<template>
  <b-card no-body>
    <b-card-body class="text-right">
      <b-button
        to="product_types/add"
        variant="primary"
      ><FeatherIcon icon="PlusIcon" />
        Ekle</b-button>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      fixed
    >
      <template #cell(title)="data">
        {{ data.item.title }}
      </template>
      <template #cell(control)="data">
        <b-button
          :to="'/product_types/edit/' + data.item.id"
          variant="outline-primary"
          size="sm"
        >
          Güncelle
        </b-button>
      </template>
    </b-table>
    <b-card-footer><b-pagination
      v-model="currentPage"
      :total-rows="dataCount"
      :per-page="perPage"
      first-number
      last-number
      prev-class="prev-item"
      next-class="next-item"
    >
      <template #prev-text>
        <feather-icon
          icon="ChevronLeftIcon"
          size="18"
        />
      </template>
      <template #next-text>
        <feather-icon
          icon="ChevronRightIcon"
          size="18"
        />
      </template>
    </b-pagination></b-card-footer>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BTable, BCardFooter, BPagination, BButton,
} from 'bootstrap-vue'

export default {
  name: 'Index',
  components: {
    BCard,
    BCardBody,
    BTable,
    BRow,
    BCol,
    BCardFooter,
    BPagination,
    BButton,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 25,
      search: '',
      fields: [
        {
          key: 'title',
          label: 'Ürün Grubu',
        },
        {
          key: 'control',
          label: 'Kontrol',
          thStyle: { width: '140px' },
        },
      ],
      dataQuery: {
        select: [
          'product_types.id AS id',
          'product_types.title AS title',
        ],
        limit: 25,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['productTypes/getProduct_types']
    },
    dataCount() {
      return this.$store.getters['productTypes/getProduct_typesCount']
    },
  },
  watch: {
    currentPage(val) {
      const page = (val - 1) * 25
      this.pagination(page)
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    pagination(page) {
      this.dataQuery.start = page
      if (this.dataQuery.start === page) {
        this.getDataList()
      }
    },
    getDataList() {
      this.$store.dispatch('productTypes/product_typesList', this.dataQuery)
    },
  },
}
</script>
